import { Field, Model } from '@datx/core';
import { JsonApiModel } from '../../core/jsonApi/jsonApiModel';
import { Approval, ConsumerData } from '../../core/types';
import { ConsumerJsonModel } from '../../consumer/consumer.json.model';
import { QuantityError } from './exercise.entity';
import { SubjectJsonModel } from '../../subject/subject.json.model';

export interface Kind {
  value: string
  option: string
}

class Condition extends Model {
  @Field()
  public left!: string;

  @Field()
  public operation!: string;

  @Field()
  public right!: string;
}

class Correct extends Model {
  @Field()
  public correct!: Condition[];
}

interface LearnItemConfig {
  exerciseSubKind?: string
}

export class ExerciseJsonModel extends JsonApiModel {
  public static override readonly type = 'exercises';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public subjectId!: string;

  @Field()
  public consumerId!: string;

  @Field()
  public name!: string;

  @Field()
  public kind!: string;

  @Field()
  public config!: LearnItemConfig;

  @Field()
  public assignments!: string[];

  @Field()
  public assets!: string[];

  @Field({
    parse: (value) => { return value ? new Date(value) : null; },
    serialize: (value) => { return value ? value.getTime().toString() : null; }
  })
  public updated!: Date;

  @Field()
  public version!: number;

  @Field()
  public approval!: Approval;

  @Field()
  public active!: boolean;

  @Field()
  public lastVersion!: string;

  @Field()
  public sortName!: string;

  @Field()
  public correct!: Correct;

  @Field()
  public copyRestricted!: boolean;

  public consumerData!: ConsumerData;

  // We do not need a relationship exercise.consumer. These getter/setters are here to assign from
  // AppState.consumers to each exerciseModel after GET
  // but do not send it back to backend on UPDATE / PATCH.
  private _consumer!: ConsumerJsonModel;
  public getConsumer(): ConsumerJsonModel { return this._consumer; }
  public setConsumer(value: ConsumerJsonModel) { this._consumer = value; }

  // Data from table competency
  private _competency!: SubjectJsonModel;
  public getCompetency(): SubjectJsonModel { return this._competency; }
  public setCompetency(value: SubjectJsonModel) { this._competency = value; }

  @Field()
  public pages!: string[];

  @Field()
  public conditionalErrors!: string[];

  @Field()
  public quantityErrors!: QuantityError[];

  @Field()
  public changedBy!: string;
}

export class ExerciseTypesJsonModel extends JsonApiModel {
  public static override readonly type = 'exercisestypes';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public kind!: string;
}
